import React from "react";

function clock(value) {
  const minutes = Math.round(Number(value) * 60);
  const hour = Math.floor(minutes / 60) % 24;
  return `${hour % 12 || 12}:${String(minutes % 60).padStart(2, "0")}${hour < 12 ? "am" : "pm"}`;
}

export default function ExplicitRoleCoverage({ coverage, roleNames = [] }) {
  if (!coverage?.uncovered?.length) return null;
  const names = new Map(roleNames.map((role) => [Number(role.id), role.role_name]));
  const windows = [];
  const latestBySignature = new Map();
  [...coverage.uncovered].sort((a, b) => a.date.localeCompare(b.date) || a.qh_num - b.qh_num).forEach((item) => {
    const signature = JSON.stringify([item.date, item.standard, item.role_type, item.role_ids, item.required, item.uncovered]);
    const last = latestBySignature.get(signature);
    if (last && Math.abs(last.end - item.qh_num) < 0.0001) {
      last.end += 0.25;
    } else {
      const window = { ...item, signature, end: item.qh_num + 0.25 };
      windows.push(window);
      latestBySignature.set(signature, window);
    }
  });
  return (
    <section aria-label="Uncovered role requirements" className="rounded-lg border border-amber-300 bg-amber-50 p-4">
      <h3 className="text-sm font-semibold text-amber-900">Role requirements need review</h3>
      <p className="mt-1 text-sm text-amber-900">{coverage.message}</p>
      <ul className="mt-2 space-y-1 text-sm text-amber-900">
        {windows.map((item, index) => (
          <li key={`${item.signature}-${index}`}>
            {item.date} · {clock(item.qh_num)}–{clock(item.end)} · {item.standard}: {item.uncovered} of {item.required} required ({item.role_ids.map((id) => names.get(Number(id)) || `Role ${id}`).join(" or ")}) uncovered
          </li>
        ))}
      </ul>
    </section>
  );
}
